export default [
	{ "label": "English", "value": "en" },
	{ "label": "Spanish", "value": "es" },
	{ "label": "French", "value": "fr" },
	{ "label": "Chinese", "value": "chinese" },
	{ "label": "Dutch", "value": "dutch" },
	{ "label": "German", "value": "german" },
  ]